import { render, staticRenderFns } from "./BaseInfoCardDotMarker.vue?vue&type=template&id=395cb1dc&scoped=true"
import script from "./BaseInfoCardDotMarker.vue?vue&type=script&lang=js"
export * from "./BaseInfoCardDotMarker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395cb1dc",
  null
  
)

export default component.exports